import React from 'react'

function MainPrice() {
  return (
    <div>MainPrice</div>
  )
}

export default MainPrice